import { render, staticRenderFns } from "./countDown.vue?vue&type=template&id=6401c265&scoped=true&"
import script from "./countDown.vue?vue&type=script&lang=js&"
export * from "./countDown.vue?vue&type=script&lang=js&"
import style0 from "./countDown.vue?vue&type=style&index=0&id=6401c265&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401c265",
  null
  
)

export default component.exports